import { render, staticRenderFns } from "./RefMenu.vue?vue&type=template&id=40dad94e&scoped=true&"
import script from "./RefMenu.vue?vue&type=script&lang=js&"
export * from "./RefMenu.vue?vue&type=script&lang=js&"
import style0 from "./RefMenu.vue?vue&type=style&index=0&id=40dad94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dad94e",
  null
  
)

export default component.exports